module.exports = __webpack_public_path__ + "img/smartby_logo_light_menu.ddeb1fcc.png";